import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import { Alert, CircularProgress, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import useApiHook from "../../hooks/useApiHook";
import FolderListBase from "./FolderListBase";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFolderRefresh } from "../../store/modal-context";

const FolderList = ({
    isActive = true,
    selectionMode = 'single',
    selectedFolderId = null,
    selectedFolderIds = null,
    onSelect = () => { },
    getFolderLink = null,
}) => {
    const { response, makeRequest, loading, error } = useApiHook();
    const location = useLocation();
    const { foldersVersion } = useFolderRefresh();

    useEffect(() => {
        if (!isActive) {
            return;
        }

        makeRequest('/folder/getAll');
    }, [foldersVersion, isActive, location.pathname, makeRequest]);

    const items = useMemo(() => {
        if (!response?.data || !Array.isArray(response.data)) {
            return [];
        }

        return response.data.map((folder) => ({
            id: folder.id,
            title: folder.name,
            icon: <FolderOutlinedIcon />
        }));
    }, [response]);

    if (loading && isActive) {
        return (
            <Stack alignItems="center" py={4}>
                <CircularProgress />
            </Stack>
        );
    }

    if (error && isActive) {
        return (
            <Alert severity="error">
                Impossibile caricare le cartelle.
            </Alert>
        );
    }

    if (isActive && items.length === 0) {
        return (
            <Stack alignItems="center" py={3}>
                <Typography variant="body2" sx={{ opacity: 0.65 }}>
                    Nessuna cartella disponibile.
                </Typography>
            </Stack>
        );
    }

    return (
        <FolderListBase
            items={items}
            selectedItemId={selectionMode === 'single' ? selectedFolderId : null}
            selectedItemIds={selectionMode === 'multiple' && Array.isArray(selectedFolderIds) ? selectedFolderIds : []}
            onItemClick={onSelect}
            getItemLink={getFolderLink}
        />
    );
};

export default FolderList;
